export default "__VITE_ASSET__D5DYv_Zi__"